import { Injectable } from '@angular/core';
import { Validators, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CustomvalidationService {
    checkPassword(control) {
        const enteredPassword = control.value;
        const passwordCheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%?=*&])(?=.{8,})/;
        return (!passwordCheck.test(enteredPassword) && enteredPassword) ? { requirements: true } : null;
    }
    
    mustMatch(controlName: string, matchingControlName: string) {
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];
    
            if (matchingControl.errors && !matchingControl.errors.mustMatch) {
                // return if another validator has already found an error on the matchingControl
                return;
            }
    
            // set error on matchingControl if validation fails
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ mustMatch: true });
            } else {
                matchingControl.setErrors(null);
            }
        }
    }

    checkInUseEmail(control) {
        // mimic http database access
        const db = ['tony@gmail.com'];
        return new Observable(observer => {
            setTimeout(() => {
                const result = (db.indexOf(control.value) !== -1) ? { alreadyInUse: true } : null;
                observer.next(result);
                observer.complete();
            }, 4000);
        });
    }

    getErrorEmail(form) {
        return form.get('email').hasError('required') ? 'This field is required' :
            form.get('email').hasError('pattern') ? 'Not a valid email address' :
                form.get('email').hasError('alreadyInUse') ? 'This email is already in use' : '';
    }

    getErrorPassword(form) {
        return form.get('password').hasError('required') ? 'This field is required (at least eight characters with one uppercase letter, one lowercase letter, one special character and one number)' :
      form.get('password').hasError('requirements') ? 'Password needs to be at least eight characters with one uppercase letter, one lowercase letter, one special character and one number' : '';
    }

    getErrorPasswordLogin(form) {
        return form.get('password').hasError('required') ? 'Password is required' :
       // form.get('password').hasError('requirements') ? 'Password needs 8 characters with 1 uppercase letter,1 lowercase letter,1 special character and 1 number': '';
       form.get('password').hasError('requirements') ? 'Password needs to be at least eight characters' : '';
    }

    getPhoneErrorMessage(form) {
        return form.get('phoneNumber').hasError('required') ? 'This field is required' :
        form.get('phoneNumber').hasError('pattern') ? 'Format must be (xxx) xxx-xxxx' : '';
      }

    // setChangeValidate(form) {
    //     form.get('validate').valueChanges.subscribe(
    //         (validate) => {
    //             if (validate === '1') {
    //                 form.get('name').setValidators([Validators.required, Validators.minLength(3)]);
    //                 const titleAlert = 'You need to specify at least 3 characters';
    //             } else {
    //                 form.get('name').setValidators(Validators.required);
    //             }
    //             form.get('name').updateValueAndValidity();
    //         }
    //     );
    // }
}
